import type { ReactNode } from "react";
import { RowIconAction } from "./RowIconAction";

// GATE-01-A (agent-logs/runs/2026-09-11-spec-219-offers/evidence/
// human-resolution-gate-01-dup-and-format.json): la celda de acciones de
// fila (contenedor `flex` alineado a la derecha + botón "Editar" detrás de
// `canEdit`) era el mismo marcado palabra por palabra en
// benefits/BenefitsScreen.tsx y offers/OffersScreen.tsx. Extracción sin
// cambio de comportamiento ni de valores visuales: ninguna pantalla que la
// use cambia un pixel por esto.
export function RowActionsCell({ children }: { children: ReactNode }) {
  return (
    <div style={{ display: "flex", gap: 6, justifyContent: "flex-end" }}>
      {children}
    </div>
  );
}

// Revisión en vivo 2026-09-22 (puntos #19/#22): convertido a
// ícono + tooltip para converger con el resto de las acciones de fila
// (`RowIconAction`). Sus tres llamadores (benefits, offers,
// message-templates) no cambian: solo dejan de dibujar un chip de texto.
export function RowEditButton({
  visible,
  onClick,
}: {
  visible: boolean;
  onClick: () => void;
}) {
  if (!visible) return null;
  return <RowIconAction label="Editar" icon="edit" onClick={onClick} />;
}
